/* Luvlyn · Contact en service (/pages/contact; ontwerp: contact.html en js/contact.js). Alleen wat deze
   pagina extra doet.
   1. Het formulier controleren: bij het verlaten van een veld (als je er iets in typte) en bij versturen.
      De foutmelding staat onder het veld en het eerste foute veld krijgt de focus. De teksten komen uit
      de instellingen van de sectie (data-ct-leeg, data-ct-klopt, data-ct-kort op het veld).
   2. Versturen: klopt alles, dan gaat het formulier echt naar Shopify (/contact), langs Shopify's
      onzichtbare hCaptcha. Klopt er iets niet, dan stopt het event hier, zodat die controle niet start.
      Voornaam en mailadres gaan even in sessionStorage, want na het versturen stuurt Shopify ze niet
      terug; de bevestiging zet ze erin. "Nog een vraag stellen" toont het formulier weer.
      Kwam Shopify zelf met een fout (zonder script, of de spamcontrole), dan krijgt dat veld de focus.
   3. Een tip bij het onderwerp dat je kiest.
   4. Hoe je ons bereikt: de dag waarop je uiterlijk antwoord hebt (de eerstvolgende werkdag; binnen
      één werkdag is een aanname uit het ontwerp). */
(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const zacht = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const gedrag = zacht ? 'instant' : 'smooth';   // niet 'auto': html heeft scroll-behavior:smooth
  const voornaam = v => v.trim().split(/\s+/)[0] || '';
  const SLEUTEL = 'luvlyn-contact';
  const bewaar = {
    zet(w){ try { sessionStorage.setItem(SLEUTEL, JSON.stringify(w)); } catch {} },
    pak(){ try { const w = JSON.parse(sessionStorage.getItem(SLEUTEL) || 'null'); sessionStorage.removeItem(SLEUTEL); return w; } catch { return null; } },
  };

  /* ---------- 1. controleren ---------- */
  const MAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  const BESTEL = /^[#A-Za-z0-9 -]{3,30}$/;
  const REGELS = {
    naam: (v, d) => v.trim().length < 2 ? d.ctLeeg : '',
    email: (v, d) => !v.trim() ? d.ctLeeg : !MAIL.test(v.trim()) ? d.ctKlopt : '',
    bestelnummer: (v, d) => !v.trim() || BESTEL.test(v.trim()) ? '' : d.ctKlopt,
    vraag: (v, d) => !v.trim() ? d.ctLeeg : v.trim().length < 10 ? d.ctKort : '',
  };
  function zetFout(veld, fout){
    const p = document.getElementById(`${veld.id}-fout`);
    if (p) { p.textContent = fout; p.hidden = !fout; }
    if (fout) veld.setAttribute('aria-invalid', 'true'); else veld.removeAttribute('aria-invalid');
  }
  function controleer(veld){
    const fout = REGELS[veld.dataset.ctRegel]?.(veld.value, veld.dataset) || '';
    zetFout(veld, fout);
    return !fout;
  }

  /* ---------- 2. versturen en de bevestiging ---------- */
  $$('[data-ct-form]').forEach(form => {
    const velden = $$('[data-ct-regel]', form);
    const bedankt = $('[data-ct-bedankt]', form.parentElement);
    velden.forEach(v => {
      v.addEventListener('input', () => { v.dataset.aangeraakt = '1'; if (v.hasAttribute('aria-invalid')) controleer(v); });
      v.addEventListener('blur', () => { if (v.dataset.aangeraakt) controleer(v); });
    });
    form.addEventListener('submit', e => {
      const fout = velden.filter(v => !controleer(v));
      // stopImmediatePropagation: Shopify's hCaptcha luistert op document en op het formulier zelf (na
      // ons aangemeld). Zonder dit begint die toch aan zijn controle en verstuurt hij daarna het
      // onvolledige formulier.
      if (fout.length) { e.preventDefault(); e.stopImmediatePropagation(); fout[0].focus(); return; }
      const naam = $('[data-ct-regel="naam"]', form), mail = $('[data-ct-regel="email"]', form);
      bewaar.zet({ naam: voornaam(naam?.value || ''), email: mail?.value.trim() || '' });
    });

    if (bedankt?.hasAttribute('data-ct-verstuurd')) {
      // net verstuurd: naam en mailadres invullen, en het adres opschonen (anders staat de bevestiging
      // er na herladen weer)
      const w = bewaar.pak();
      const kop = $('[data-ct-kop]', bedankt);
      if (w?.naam && kop) kop.textContent = kop.dataset.ctKop.replace('[naam]', w.naam);
      if (w?.email) $$('[data-ct-email]', bedankt).forEach(x => { x.textContent = w.email; });
      const url = new URL(location.href);
      if (url.searchParams.has('contact_posted')) { url.searchParams.delete('contact_posted'); url.hash = 'formulier'; history.replaceState(null, '', url); }
      requestAnimationFrame(() => {
        bedankt.focus({ preventScroll: true });
        bedankt.scrollIntoView({ block: 'center', behavior: 'instant' });
      });
    } else {
      // een fout van Shopify zelf: dat veld krijgt de focus
      const fout = $('[aria-invalid="true"]', form) || ($('[data-ct-fout-server]', form) && velden[0]);
      if (fout) requestAnimationFrame(() => { fout.focus({ preventScroll: true }); fout.scrollIntoView({ block: 'center', behavior: 'instant' }); });
    }

    $('[data-ct-opnieuw]', bedankt)?.addEventListener('click', () => {
      form.reset();
      velden.forEach(v => { delete v.dataset.aangeraakt; zetFout(v, ''); });
      $$('[data-ct-tip]', form).forEach(t => { t.hidden = true; });
      bedankt.hidden = true;
      form.hidden = false;
      velden[0]?.focus({ preventScroll: true });
      form.scrollIntoView({ block: 'nearest', behavior: gedrag });
    });
  });

  /* ---------- 3. een tip bij het onderwerp ---------- */
  $$('[data-ct-onderwerp]').forEach(fs => {
    const tips = $$('[data-ct-tip]', fs);
    fs.addEventListener('change', e => {
      const sleutel = e.target.dataset.ctSleutel;
      if (sleutel) tips.forEach(t => { t.hidden = t.dataset.ctTip !== sleutel; });
    });
  });

  /* ---------- 4. de dag van je antwoord: de eerstvolgende werkdag ---------- */
  const DAG = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
  const MAAND = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];
  function antwoordDag(nu = new Date()){
    const d = new Date(nu); d.setHours(12, 0, 0, 0);
    do { d.setDate(d.getDate() + 1); } while (d.getDay() === 0 || d.getDay() === 6);
    return `${DAG[d.getDay()]} ${d.getDate()} ${MAAND[d.getMonth()]}`;
  }
  $$('[data-ct-antwoord]').forEach(el => {
    const zin = el.dataset.ctAntwoord;
    if (!zin || !zin.includes('[dag]')) return;
    const [voor, na] = zin.split('[dag]');
    const b = document.createElement('b'); b.textContent = antwoordDag();
    el.replaceChildren(voor, b, na);
  });
})();
